// extracted by mini-css-extract-plugin
export default {"next":"styles_next__4ASTr","counter":"styles_counter__1MRAz","modal":"styles_modal__u2++t","innerHolder":"styles_innerHolder__2Jfn0","opacityLayer":"styles_opacityLayer__Rv+AO"};